import {ToUpper} from './general-data';
import store from '@/store';
import Errors from '@/settings/errors';

export const ParseErrorText = (errors, showAll = false) => {
  if (!errors || !Object.keys(errors).length)
    return '';

  let res = [];

  if (typeof errors == 'string')
    res[0] = errors;
  else if (Array.isArray(errors))
    res = errors;
  else
    Object.keys(errors).forEach(key => {
      if (errors[key].length)
        errors[key].forEach(err => {
          res.push(`${key == 'base' ? '' : ToUpper(key) + ': '}${err}`);
        });
    });

  return showAll ? res : res[0];
}

export const ParseErrParams = (err) => {
  if (
    !err ||
    !err.response ||
    !err.response.config
  )
    return '';

  let conf = err.response.config;

  if (conf.params)
    return JSON.stringify(conf.params);
  else if (conf.data)
    return JSON.stringify(conf.data);
  else
    return '';
}

export const GlobalErrorHandler = (error, app, ignoreExeptions) => {

  if (!error || !error.response) {
    hideSpinner(app);
    return;
  }

  if (
    (
      checkUrlExeptions(error.response) &&
      !ignoreExeptions
    ) ||
    // Errors.urlExeptions.find(url => error.response.config.url.includes(url)) || // don't catch exeptions
    error.response.status == 401 ||
    error.response.status == 419
  ) {
    hideSpinner(app);
    return;
  }

  let errors = [];
  if (error.response.data && error.response.data.errors) {
    errors = ParseErrorText(error.response.data.errors, true);    
  } else {
    errors = ['Unknown error (no error text provided)']
  }

  store.dispatch('CheckAuth')
    .then(() => store.dispatch('addApiError', {
      feature_name: 'Error',
      feature_url: window.location.href,
      request_url: `${error.response.config.method} ${error.response.config.url}`,
      request_params: ParseErrParams(error),
      response_text: error.response.request.responseText,
      response_status_code: error.response.status,
      errors: errors
    })
  )
  
  hideSpinner(app);
}

const hideSpinner = (component) => {
  if (component.showSpinner)
    component.showSpinner = false;

  component.$children.forEach(child => {
    hideSpinner(child);
  });
}

const checkUrlExeptions = (err) => {
  if (!err.config)
    return false;

  return Errors.urlExeptions.find(ex => {
    if (typeof ex == 'object') {
      return (
        err.config.url.includes(ex.url) &&
        err.config.method == ex.method.toLowerCase()
      )
    } else {
      return err.config.url.includes(ex);
    }
  });
}